import React, { createContext, useEffect, useState, useRef } from "react";
import { isNull } from "App/utils/helpers";
import { FORM_RESET_STATE_DETAIL, FORM_RESET_STATE_WMS_RMT } from "../helpers";
import { WMS_FA_HELPDESK } from "App/constants";
import { DEFAULT_SHOW_BUTTON_SUBMIT } from "App/constants";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", children, data, menu }) => {
  const oldFormDataHD = useRef(null);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [showModalHistory, setShowModalHistory] = useState(false);
  const [showModalVerifikasi, setShowModalVerifikasi] = useState(false);
  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return FORM_RESET_STATE_WMS_RMT;
    } else {
      if (menu === WMS_FA_HELPDESK) {
        oldFormDataHD.current = data;
        return data;
      } else {
        if (isNull(oldFormDataHD.current)) {
          return FORM_RESET_STATE_WMS_RMT;
        } else {
          return oldFormDataHD.current;
        }
      }
    }
  });

  const [validasi, setValidasi] = useState(false);
  const [aksesFile, setAksesFile] = useState(false);
  const [listDetail, setListDetail] = useState([]);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [formDetail, setFormDetail] = useState(FORM_RESET_STATE_DETAIL);

  // const [formData, setFormData] = useState(FORM_RESET_STATE_WMS_RMT)
  useEffect(() => {
    if (isNull(data)) {
      setFormData(FORM_RESET_STATE_WMS_RMT);
    } else {
      if (menu === WMS_FA_HELPDESK) {
        oldFormDataHD.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormDataHD.current)) {
          setFormData(FORM_RESET_STATE_WMS_RMT);
        } else {
          setFormData(oldFormDataHD.current);
        }
      }
    }
  }, [data]); // eslint-disable-line
  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData,
        disabled,
        setDisabled,
        showModalBarang,
        setShowModalBarang,
        listDetail,
        setListDetail,
        showModalVerifikasi,
        setShowModalVerifikasi,
        validasi,
        setValidasi,
        showModalHistory,
        setShowModalHistory,
        aksesFile,
        setAksesFile,
        formDetail,
        setFormDetail
      }}>
      {children}
    </FormContext.Provider>
  );
};
